import React, { useEffect } from 'react'
import { RouteComponentProps, useParams } from '@reach/router'
import { useNavigate } from '@reach/router'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/client'

export const VerifyToken: React.FC<RouteComponentProps> = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [verify] = useMutation(LOGIN_TOKEN_VERIFICATION)

  useEffect(() => {
    verify({
      variables: {
        id: id
      }
    })
      .then(() => {
        navigate('/voter/ballot')
      })
      .catch((err) => {
        navigate('/')
      })
  }, [])

  return <div>Please wait...</div>
}

const LOGIN_TOKEN_VERIFICATION = gql`
  mutation loginTokenVerification($id: String!) {
    verify: loginByMagicLink(id: $id) {
      token
    }
  }
`
